import { useEffect, useState } from "react";
import { api, apiErr } from "@/admin/api";
import { PageTitle, StatCard } from "@/admin/ui";
import { MousePointerClick, Send, Inbox, TrendingUp, Loader2 } from "lucide-react";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/analytics").then(({ data }) => setData(data)).catch((e) => console.error(apiErr(e)));
  }, []);

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-terracotta" /></div>;
  const max = Math.max(1, ...data.cta_clicks.map((c) => c.count));

  return (
    <div data-testid="admin-analytics">
      <PageTitle title="Analytics" subtitle="Engagement and conversion at a glance" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard icon={MousePointerClick} label="Total CTA Clicks" value={data.total_cta_clicks} />
        <StatCard icon={Send} label="Form Submissions" value={data.form_submissions} />
        <StatCard icon={Inbox} label="Total Inquiries" value={data.total_inquiries} />
        <StatCard icon={TrendingUp} label="Click → Inquiry Rate" value={`${data.conversion_rate}%`} />
      </div>

      <div className="bg-white rounded-2xl border border-bone p-6">
        <h2 className="font-serif text-2xl font-semibold text-ink mb-5">CTA Clicks by Button</h2>
        {data.cta_clicks.length === 0 ? <p className="text-ink-soft text-sm">No CTA clicks tracked yet.</p> : (
          <div className="space-y-3">
            {data.cta_clicks.map((c) => (
              <div key={c.cta}>
                <div className="flex justify-between text-sm mb-1"><span className="text-ink font-medium">{c.cta}</span><span className="text-ink-soft">{c.count}</span></div>
                <div className="h-2 bg-bone rounded-full overflow-hidden"><div className="h-full bg-terracotta rounded-full" style={{ width: `${(c.count / max) * 100}%` }} /></div>
              </div>
            ))}
          </div>
        )}
        <p className="text-xs text-ink-soft mt-6">Note: page views, traffic source and device breakdown are tracked in Google Analytics (GA4) once your Measurement ID is added. This panel reflects on-site CTA & form events.</p>
      </div>
    </div>
  );
}
